import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'Actions/router';
import * as styles from './yearSelect.css';

const YearSelect = ({ years, active, onChange, isMegaTitle }) => (
  <select
    className={[
      styles.select,
      isMegaTitle ? styles.selectMega : '',
    ].join(' ')}
    value={active}
    onChange={onChange}
  >
    {years.map((year) => <option key={year} value={year}>{year}</option>)}
  </select>
);

YearSelect.defaultProps = {
  mega: false,
};

YearSelect.propTypes = {
  years: PropTypes.arrayOf(PropTypes.string).isRequired,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  // Used in mapDispatchToProps
  id: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  isMegaTitle: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch, { id, fullId }) => {
  if (fullId) {
    return {
      onChange: ({ target: { value } }) =>
        dispatch(push({ [fullId]: { year: value } })),
    };
  }

  return {
    onChange: ({ target: { value } }) =>
      dispatch(push({ [id]: { year: value } })),
  };
};

export default connect(undefined, mapDispatchToProps)(YearSelect);
export { YearSelect };



// WEBPACK FOOTER //
// ./app/components/yearSelect/index.js